module.exports = __webpack_public_path__ + "img/2_179.6fdcef75.png";